// lodash
import find from 'lodash/find';

import { countryCodeIsInternational } from '../address/addressHelpers';

export function getDefaultDeliveryAddress(addressBook = []) {
  const ukDefaultAddress = find(addressBook, addressRecord => addressRecord.defaultShipping
    && !countryCodeIsInternational(addressRecord.address.countryCode));
  const ukContactAddress = find(addressBook, addressRecord => addressRecord.contact
    && !countryCodeIsInternational(addressRecord.address.countryCode));
  const firstUkAddressEntry = find(addressBook, addressRecord => !countryCodeIsInternational(
    addressRecord.address.countryCode,
  ));

  return (
    ukDefaultAddress ||
    ukContactAddress ||
    firstUkAddressEntry ||
    undefined
  );
}

export function getDefaultDeliveryAddressAvailableForDelivery(addressBook) {
  const ukDefaultAddress = find(addressBook, addressRecord => addressRecord.defaultShipping
    && !countryCodeIsInternational(addressRecord.address.countryCode) && !addressRecord.notAvailableForDelivery);
  const ukContactAddress = find(addressBook, addressRecord => addressRecord.contact
    && !countryCodeIsInternational(addressRecord.address.countryCode) && !addressRecord.notAvailableForDelivery);
  const firstAddressEntry = find(addressBook, addressRecord => !countryCodeIsInternational(
    addressRecord.address.countryCode,
  ) && !addressRecord.notAvailableForDelivery);

  // UKdefaultAddress -> UKcontactAddress -> firstAddressInAddressBook
  return (
    ukDefaultAddress ||
    ukContactAddress ||
    firstAddressEntry ||
    undefined
  );
}
